import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { CheckCircle } from "lucide-react";

const DigitalMarketing = () => {
  return (
    <main>

      {/* 🔥 HERO */}
      <section
        style={{
          backgroundImage:
            "linear-gradient(rgba(5,25,55,0.85), rgba(5,25,55,0.9)), url('https://images.pexels.com/photos/6476259/pexels-photo-6476259.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          padding: "100px 0",
          textAlign: "center"
        }}
      >
        <Container>
          <h1 style={{ fontWeight: "700" }}>
            Digital Marketing & Growth Solutions
          </h1>
          <p style={{ maxWidth: "700px", margin: "auto" }}>
            We combine marketing strategy with technology to help businesses
            grow online, generate leads, and build a strong digital presence.
          </p>
        </Container>
      </section>

      {/* 🔹 INTRO */}
      <section className="gov-section">
        <Container>
          <Row className="align-items-center g-5">

            <Col lg={6}>
              <h2>Boost Your Online Presence</h2>
              <p>
                Our digital marketing services are designed to deliver measurable
                results through SEO, social media, and performance marketing.
              </p>

              <ul style={{ listStyle: "none", padding: 0 }}>
                {[
                  "Increase website traffic",
                  "Generate quality leads",
                  "Improve brand visibility",
                  "Data-driven marketing strategy"
                ].map((item, i) => (
                  <li key={i} className="d-flex gap-2 mb-2">
                    <CheckCircle size={18} color="green" />
                    {item}
                  </li>
                ))}
              </ul>
            </Col>

            <Col lg={6}>
              <img
                src="https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg"
                alt="marketing"
                style={{ width: "100%", borderRadius: "10px" }}
              />
            </Col>

          </Row>
        </Container>
      </section>

      {/* 🔹 SERVICES GRID */}
      <section className="gov-section gov-section-alt">
        <Container>
          <h2 className="text-center mb-5">Our Digital Marketing Services</h2>

          <Row className="g-4">

            {[
              "Search Engine Optimization (SEO)",
              "Social Media Marketing",
              "Google Ads & PPC",
              "Content Marketing",
              "Website Optimization",
              "Analytics & Reporting"
            ].map((item, i) => (
              <Col md={6} lg={4} key={i}>
                <Card className="gov-card p-4 h-100 text-center">
                  <h5>{item}</h5>
                  <p>
                    Strategic execution focused on performance and ROI.
                  </p>
                </Card>
              </Col>
            ))}

          </Row>
        </Container>
      </section>

      {/* 🔥 STRATEGY SECTION */}
      <section
        style={{
          backgroundImage:
            "linear-gradient(rgba(0,0,0,0.75), rgba(0,0,0,0.8)), url('https://images.pexels.com/photos/577585/pexels-photo-577585.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          padding: "80px 0"
        }}
      >
        <Container>
          <h2 className="text-center mb-5">Our Approach</h2>

          <Row className="g-4 text-center">
            {[
              "Business Analysis",
              "SEO & Market Research",
              "Strategy Planning",
              "Campaign Execution",
              "Optimization",
              "Performance Reporting"
            ].map((step, index) => (
              <Col md={4} key={index}>
                <Card className="p-4 h-100 bg-dark text-white border-0">
                  <h5>Step {index + 1}</h5>
                  <p>{step}</p>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* 🔥 PRICING */}
     {/* 🔥 PRICING (PREMIUM VERSION) */}
<section className="gov-section">
  <Container>
    <h2 className="text-center mb-5">Digital Marketing Plans</h2>

    <Row className="g-4">

      {/* BASIC */}
      <Col md={4}>
        <Card className="gov-card p-4 h-100">
          <h5 className="text-center">Starter</h5>
          <h3 className="text-center">₹9,999 / month</h3>

          <hr />

          <p><strong>SEO</strong></p>
          <ul>
            <li>5 Keywords Optimization</li>
            <li>On-page SEO (Meta, Titles)</li>
            <li>Basic Technical Fixes</li>
          </ul>

          <p><strong>Social Media</strong></p>
          <ul>
            <li>2 Platforms (FB / Insta)</li>
            <li>8 Posts / Month</li>
          </ul>

          <p><strong>Ads</strong></p>
          <ul>
            <li>Basic Google Ads Setup</li>
            <li>1 Campaign</li>
          </ul>

          <p><strong>Reporting</strong></p>
          <ul>
            <li>Monthly Report</li>
          </ul>

          <Button variant="outline-primary" className="w-100">
            Get Started
          </Button>
        </Card>
      </Col>

      {/* PROFESSIONAL */}
      <Col md={4}>
        <Card
          className="p-4 h-100"
          style={{
            border: "2px solid #0d3b66",
            transform: "scale(1.05)"
          }}
        >
          <h5 className="text-center">Professional</h5>
          <h3 className="text-center">₹24,999 / month</h3>

          <hr />

          <p><strong>SEO</strong></p>
          <ul>
            <li>15 Keywords Optimization</li>
            <li>On-page + Technical SEO</li>
            <li>Blog Strategy (2 Blogs)</li>
          </ul>

          <p><strong>Social Media</strong></p>
          <ul>
            <li>3 Platforms</li>
            <li>16 Posts / Month</li>
            <li>Basic Engagement</li>
          </ul>

          <p><strong>Ads</strong></p>
          <ul>
            <li>Google + Meta Ads</li>
            <li>3 Campaigns</li>
            <li>Conversion Tracking</li>
          </ul>

          <p><strong>Reporting</strong></p>
          <ul>
            <li>Bi-weekly Reports</li>
            <li>Performance Insights</li>
          </ul>

          <Button variant="dark" className="w-100">
            Most Popular
          </Button>
        </Card>
      </Col>

      {/* ADVANCED */}
      <Col md={4}>
        <Card className="gov-card p-4 h-100">
          <h5 className="text-center">Advanced</h5>
          <h3 className="text-center">₹49,999 / month</h3>

          <hr />

          <p><strong>SEO</strong></p>
          <ul>
            <li>30+ Keywords</li>
            <li>Advanced Technical SEO</li>
            <li>Content Strategy + 4 Blogs</li>
          </ul>

          <p><strong>Social Media</strong></p>
          <ul>
            <li>All Platforms</li>
            <li>25+ Posts / Month</li>
            <li>Full Engagement Handling</li>
          </ul>

          <p><strong>Ads</strong></p>
          <ul>
            <li>Multi-channel Ads</li>
            <li>Retargeting Campaigns</li>
            <li>Landing Page Optimization</li>
          </ul>

          <p><strong>Advanced Features</strong></p>
          <ul>
            <li>AI Insights & Optimization</li>
            <li>Dedicated Account Manager</li>
          </ul>

          <Button variant="primary" className="w-100">
            Get Started
          </Button>
        </Card>
      </Col>

    </Row>
  </Container>
</section>

      {/* 🔥 WHY US */}
      <section className="gov-section gov-section-alt">
        <Container>
          <Row className="align-items-center g-5">

            <Col lg={6}>
              <img
                src="https://images.pexels.com/photos/3183153/pexels-photo-3183153.jpeg"
                alt="team"
                style={{ width: "100%", borderRadius: "10px" }}
              />
            </Col>

            <Col lg={6}>
              <h2>Why Choose IGT?</h2>

              <ul style={{ listStyle: "none", padding: 0 }}>
                {[
                  "Technology + Marketing combined",
                  "AI-driven strategy",
                  "Performance-focused approach",
                  "Real business growth focus",
                  "End-to-end support"
                ].map((item, i) => (
                  <li key={i} className="d-flex gap-2 mb-2">
                    <CheckCircle size={18} color="green" />
                    {item}
                  </li>
                ))}
              </ul>
            </Col>

          </Row>
        </Container>
      </section>

      {/* 🔥 CTA */}
      <section
        style={{
          background: "linear-gradient(135deg, #0d3b66, #1d3557)",
          color: "white",
          padding: "80px 0",
          textAlign: "center"
        }}
      >
        <Container>
          <h2>Ready to Grow Your Business?</h2>
          <p>Let’s create a strategy that delivers real results.</p>

          <Button href="/contact" size="lg" variant="light">
            Contact Us
          </Button>
        </Container>
      </section>

    </main>
  );
};

export default DigitalMarketing;